// extracted by mini-css-extract-plugin
export var callCard = "_b0-0";
export var callMessageButton = "_b0-1";
export var helpIcon = "_b0-3";
export var helpIconContainer = "_b0-4";
export var verticalDivider = "_b0-2";